import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/onboarding/legal/forms/targetedFinancialInstrumentsForm';

export const InformationAboutOperationsFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <Field.Quantity
        fullWidth
        label={t(
          `onboarding.targetedFinancialInstruments.informationAboutOperations.expectedMonthlyTradeQuantity.label`
        )}
        name="expectedMonthlyTradeQuantity"
        placeholder={t(
          `onboarding.targetedFinancialInstruments.informationAboutOperations.expectedMonthlyTradeQuantity.placeholder`
        )}
      />
      <Field.Quantity
        fullWidth
        label={t(
          `onboarding.targetedFinancialInstruments.informationAboutOperations.expectedYearlyTradeQuantity.label`
        )}
        name="expectedYearlyTradeQuantity"
        placeholder={t(
          `onboarding.targetedFinancialInstruments.informationAboutOperations.expectedYearlyTradeQuantity.placeholder`
        )}
      />
    </>
  );
};
